<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I dedicate this book to the memory of my wife, Katy, and my friends who departed this world before me. To the men and women who shaped the world where I grew up in Terrebonne Heights and to friends who wanted these stories recorded before I took them to the grave.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3ee218d3